module.exports = __webpack_public_path__ + "static/media/wtrans_bru.ad9468de.pdf";